<template>
  <div>
    <div id="wrapper" class="d-flex">
      <div id="page-content-wrapper">
        <nav
          ref="navbarEl"
          class="navbar navbar-expand-lg navbar-light bg-na-principal border-bottom fixed-top custom-navbar"
          :class="{ 'mobile-responsive': isMobile }"
          :style="navStyle"
        >
          <!-- El sidebar principal (#sidebar) solo se comporta como drawer
          móvil (toggleable por este botón) dentro de su propio
          @media (max-width: 768px) en mobile.css -- fuera de ese ancho crudo
          de ventana, el sidebar se muestra siempre expandido sin importar si
          el panel del Asistente IA está anclado, así que el hamburguesa no
          tiene nada que mostrar/ocultar ahí. Antes también aparecía con
          isAiAssistantDocked, lo cual lo mostraba (en su estado "activo"/X)
          en pantallas anchas donde todo cabía y no había drawer que abrir. -->
          <Hamburger v-if="isMobile" />
          <div
            class="sidebar-heading"
            :class="{ 'sidebar-heading--critical': navCritical }"
          >
            <img :src="logoImgUrl" width="190px" height="63px" alt="logo" />
          </div>
          <div
            id="navbarSupportedContent"
            class="collapse navbar-collapse show float-right left"
          >
            <ul
              class="navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center"
            >
              <li id="action-item-searchbar" class="nav-item">
                <StudentSearch
                  :nav-compact="navCompact"
                  @showStudentInfo="showStudentInfo"
                />
              </li>
              <li
                v-if="userHasPermissions('academic.helpfab.view')"
                class="mr-2"
              >
                <div class="dropdown dropdown-help">
                  <button
                    id="btnhelp"
                    type="button"
                    class="btn btn-secondary dropdown-toggle d-flex align-items-center dropdown-toggle-help"
                    :class="{ 'dropdown-toggle-help--compact': navCompact }"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      src="@/assets/img/circle-question.svg"
                      alt="circle-question"
                      class="mr-2"
                    />
                    <span class="help-btn-label">Ayuda</span>
                  </button>
                  <div class="dropdown-menu mt-1" aria-labelledby="btnhelp">
                    <a
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                      @click="handleOpenCloseTicketFlow"
                    >
                      <img
                        src="@/assets/img/circle-plus.svg"
                        alt="circle-plus"
                        class="mr-2 ml-n2"
                      />
                      Crear un Ticket
                    </a>
                    <a
                      v-if="userHasPermissions('operations.chatbotbtn')"
                      class="dropdown-item d-flex align-items-center"
                      href="#"
                      @click="handleOpenCloseVirtualAssistant"
                    >
                      <img
                        src="@/assets/img/sparkles.svg"
                        alt="sparkles"
                        class="mr-2 ml-n2"
                      />
                      Asistente Virtual
                    </a>
                    <a
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                      @click="handleNavigateToMyTickets"
                    >
                      <img
                        src="@/assets/img/ticket.svg"
                        alt="ticket"
                        class="mr-2 ml-n2"
                      />
                      Mis Tickets
                    </a>
                  </div>
                </div>
              </li>

              <li class="d-flex nav-item mr-2">
                <a
                  id="action-item-forms"
                  class="cursor-pointer form_link px-3 text-center text-truncate"
                  :class="{ 'form_link--compact': navCompact }"
                  role="button"
                  @click="goToFormManagement"
                >
                  <em class="fas fa-file-invoice form_icon form-link-icon" />
                  <span class="form-link-label">Formularios</span>
                </a>
              </li>

              <li
                v-if="false"
                id="action-item-notification"
                class="nav-item dropdown no-arrow mx-1"
                style="display: contents"
              >
                <a class="nav-icon-link cursor-pointer mr-2">
                  <li class="nav-item">
                    <span class="avatar avatar-sm rounded-circle">
                      <em class="fas fa-bell iconNav2" />
                    </span>
                  </li>
                  <span v-if="false" class="rounded-circle alert-indicator">
                    3
                  </span>
                </a>

                <div class="dropdown">
                  <a
                    v-if="false"
                    id="action-item-help"
                    class="cursor-pointer mr-2 nav-icon-link"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="closeSearchBar"
                  >
                    <li class="nav-item">
                      <span class="avatar avatar-sm rounded-circle">
                        <em class="fal fa-question-circle iconNav1" />
                      </span>
                    </li>
                  </a>
                  <div
                    class="dropdown-list dropdown-menu dropdown-menu-custom custom-right"
                    aria-labelledby="action-item-help"
                  >
                    <a
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                    >
                      <div class="mr-3 div-help">
                        <em class="fas fa-book" />
                      </div>
                      <div class="help-text">
                        <span class="text-hepl-grid">
                          <strong>Manual</strong>
                        </span>
                      </div>
                    </a>
                    <div class="dropdown-divider" />
                    <a class="dropdown-item d-flex align-items-center" href="#">
                      <div class="mr-3 div-help mb-1">
                        <em class="fas fa-video" />
                      </div>
                      <div class="help-text mb-1">
                        <span class="text-hepl-grid">
                          <strong>Videos</strong>
                        </span>
                      </div>
                    </a>
                    <a
                      class="dropdown-item support-table shadow-top bg-white px-0 pl-1"
                    >
                      <div
                        class="div-help d-flex flex-column align-items-center py-3"
                      >
                        <img
                          src="../../assets/img/helpdesk_icon.svg"
                          width="62px"
                          height="62px"
                          alt="help"
                        />
                        <div
                          class="color-gray-7 font-16 font-weight-bold d-flex justify-content-center mt-1"
                        >
                          Mesa de Apoyo
                        </div>
                      </div>
                    </a>
                    <!-- JSF: según la US 79818 - se pidió ocultar el botón Crear Solicitud porque actualmente no tiene la funcionalidad.
                  Cuando se cree la funcionalidad pues se habilita nuevamente. -->
                    <div v-if="false" class="cursor-pointer border-top">
                      <div class="dropdown-item nav-list-item">
                        <em class="fas fa-file-plus font-20 color-green mr-2" />
                        <div
                          class="color-black font-16 font-weight-normal ml-2 pl-1"
                        >
                          Crear Solicitud
                        </div>
                      </div>
                    </div>
                    <div
                      class="cursor-pointer border-top"
                      @click="onNavigateToViewTickets"
                    >
                      <div class="dropdown-item nav-list-item">
                        <em
                          class="fas fa-file-search font-20 color-green mr-2"
                        />
                        <div
                          class="color-black font-16 font-weight-normal ml-1"
                        >
                          Ver Solicitudes
                        </div>
                      </div>
                    </div>
                    <div
                      class="border-top d-flex flex-column align-items-center py-2 color-gray-6 font-12 font-italic"
                    >
                      <div>
                        <a
                          class="font-weight-bold color-gray-6"
                          href="mailto:asistencia-mipe@de.pr.gov"
                        >
                          asistencia-mipe@de.pr.gov
                        </a>
                      </div>
                      <div class="font-weight-normal mt-1">787-773-6147</div>
                    </div>
                  </div>
                </div>
              </li>

              <CustomUserInfo
                :row-elements="userCard.rowElements"
                :row-actions="userCard.rowActions"
                :last-login-date="userCard.lastLogin"
                class="user-info__extended custom-right"
              />
            </ul>
          </div>
        </nav>
        <div class="container-fluid student-container pr-0">
          <SelectedStudent
            v-if="hasStudentSelected && showSelectedStudent"
            ref="SelectedStudent"
            :student="selectedStudent"
            @DeselectedStudent="onDeselectedStudent"
            @showStudentInfo="showStudentInfo"
          />
        </div>
      </div>
      <modal-password
        :show="showModalPassword"
        @on-close="showModalPassword = false"
        @submit="handleSubmitChangePassword"
      />
      <student-search-info
        class="student-search-info__extended"
        show-btn-update-general-info
        show-btn-update-school-location
        show-btn-update-dates
        show-btn-update-address-info
        :show-btn-update-impediment="showBtnUpdateImpediment"
        :show="studentSieId !== null"
        :academic-years="academicYears"
        :pei-history-data="peiHistoryData"
        :status-list="studentStatuses"
        :municipality-list="municipalityList"
        :canEdit="$store.getters.HasPermission('student.update.municipality')"
        :student-info="studentInfo"
        :enrollment-school-data="enrollmentSchoolData"
        :therapies="therapies"
        :can-change-status="
          $store.getters.HasPermission('student.canchangestatus')
        "
        :can-edit-student-dates="
          $store.getters.HasPermission('student.canchangedates')
        "
        :update-student-dates="updateStudentDates"
        @on-close="onCloseStudentSearchHandler"
        @change-status="onChangeStatusHandler"
        @update-student-sie="onUpdateStudentSieHandler"
        @refresh-address="onRefreshAddressHandler"
        @loadPeiInfo="loadPeiInfo"
        @loadenrollmentSchoolData="loadenrollmentSchoolData"
        @loadTherapyInfo="loadTherapyInfo"
        @change-municipality="onChangeMunicipalityHandler"
        @update-impediment="onUpdateImpedimentHandler"
      />
      <my-profile
        v-if="profileModalVisible"
        v-model="profileModalVisible"
        :user-info="user"
        :save-profile="updateMyProfile"
      />
      <profile-info
        v-if="updateProfileVisible"
        :save-profile="updateMyProfile"
        :user="user"
        value
        @close="updateProfileVisibleHandler"
      />
    </div>
    <create-ticket-flow @close="handleOpenCloseTicketFlow" />
    <virtual-assistant @close="handleOpenCloseVirtualAssistant" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import store from '@/store/index';
import StudentSearch from '@/components/student/search/Search';
import SelectedStudent from '@/components/student/SelectedStudent';
import StudentSearchInfo from 'student-search-info';
import router from '@/router/index';
import { Hamburger } from './components';
import { DASHBOARD_URL } from '@/config';
import CustomUserInfo from 'CustomUserInfoPanel';
import { MyProfile, ProfileInfo } from 'mipe-security';
import { updateMyProfile as _updateMyProfile } from '@/modules/user/api.js';
import { changeUserPassword } from '@/modules/user/api.js';
import studentService, {
  getStudentStatuses as _getStudentStatuses,
  getStudentPeiHistory as _getStudentPeiHistory,
  updateStudentDates as _updateStudentDates,
} from '@/modules/student/api';
import academicYearService from '@/modules/common/academicyear.api.js';
import ModalPassword from '@quisit/mipe-modal-password';
import loading from '@quisit/mipe-utils/mixins/loading/index';
import { getMunicipalities } from '@/services/api/tapRequest.api.js';
//store modules
import { name as studentModuleName } from '@/modules/student';
import commentTypes from '@/utils/constants/comment/commentTypes';
import EnumStudentStatuses from '@/utils/constants/student/studentStatuses';
import commentsStore from '@/views/comments/comments-store';
import CreateTicketFlow from '@/views/helpdesk/TicketFlow';
import VirtualAssistant from '@/views/virtual-assistant';

//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

const CASE_LIST_ROUTE_NAME = 'CaseListMain';
const CREATE_CASE_ROUTE_NAME = 'CreateTicket';
const KEY_PROFILE_UPDATED = 'profile-update-flag';
const DEFAULT_PEI_HISTORY_PAGE_SIZE = 10;
const MODULES = {
  STUDENT: 'e2ab3f04-b958-4755-8a1b-da0b75920104',
};

import logoUrl from '../../assets/img/academico.svg';
import logoTrainingUrl from '../../assets/img/academico-training.svg';

export default {
  mixins: [alertMixin, loading],
  components: {
    StudentSearch,
    SelectedStudent,
    Hamburger,
    StudentSearchInfo,
    CustomUserInfo,
    MyProfile,
    ProfileInfo,
    ModalPassword,
    CreateTicketFlow,
    VirtualAssistant,
  },
  data() {
    return {
      IsStudentSet: store.getters['$_student/StudentSie'],
      studentSieId: null,
      profileModalVisible: false,
      updateProfileVisible: false,
      studentInfo: {},
      enrollmentSchoolData: [],
      peiHistoryData: {},
      academicYears: [],
      therapies: [],
      studentStatuses: [],
      municipalityList: [],
      showModalPassword: false,
      loadingColor: '#41b883',
      loadingBackground: '#ffffff',
      // Ancho real disponible del navbar (ResizeObserver en mounted()) --
      // ver computed navCompact/navCritical más abajo.
      navAvailableWidth: null,
    };
  },
  methods: {
    ...mapMutations(studentModuleName, [
      'setSelectedStudentStatus',
      'setSelectedMunicipality',
    ]),
    // Mide el ancho real del <nav> (ref="navbarEl") -- refleja tanto un resize
    // real de ventana como el angostamiento por el panel docked del Asistente
    // IA (navStyle() le cambia el "right" inline), sin depender de @media por
    // ancho de ventana cruda. Ver computed navCompact/navCritical.
    observeNavWidth() {
      if (!window.ResizeObserver || !this.$refs.navbarEl) return;
      this._navResizeObserver = new ResizeObserver((entries) => {
        const entry = entries && entries[0];
        if (entry) {
          this.navAvailableWidth = entry.contentRect.width;
        }
      });
      this._navResizeObserver.observe(this.$refs.navbarEl);
    },
    async showStudentInfo(value) {
      this.studentInfo = {};
      const studentId = +value;

      if (studentId) {
        this.studentSieId = value;

        //close student search box
        this.closeSearchBar();

        //get student enrollent school info
        await this.getStudentInfo();
        await this.getMunicipalities();
        //get academic years list
        this.academicYears = (
          await academicYearService.getAcademicYears()
        ).data;

        //get student statuses
        await this.getStudentStatuses(
          +this.studentInfo?.mipeStudent?.studentStatusCode || null
        );
      }
    },
    async loadPeiInfo(studentId) {
      await this.getPeiHistory(studentId);
    },
    async loadenrollmentSchoolData(studentId) {
      await this.getEnrollmentSchool(studentId);
    },
    async loadTherapyInfo(studentId) {
      //get therapies
      //
      await this.getStudentTherapies(studentId);
    },
    goToFormManagement() {
      this.$router.push({ path: '/operations/formManagement' });
    },
    async logoff() {
      await store.dispatch('$_user/logout');
    },
    async onDeselectedStudent() {
      await store.commit('$_student/clearSelectedStudent');
      this.studentSieId = null; //Clear student selected
      const pathToRedirect = this.$router.currentRoute.path.startsWith(
        '/student/comments'
      )
        ? '/'
        : null;
      if (pathToRedirect) {
        router.push({ path: pathToRedirect });
      }
    },
    StudentSearchedHistory() {
      store.dispatch('$_student/getUserStudentSearchedHistory', { root: true });
    },
    closeSearchBar() {
      store.commit('$_student/toggleSearchMenu', false);
    },
    goToDashboard() {
      window.open(DASHBOARD_URL, '_blank');
    },
    onNavigateToViewTickets() {
      this.$router.push({
        name: CASE_LIST_ROUTE_NAME,
      });
    },
    onNavigateToCreateTicket() {
      this.$router.push({
        name: CREATE_CASE_ROUTE_NAME,
      });
    },
    profileModalVisibilityHandler(state) {
      this.profileModalVisible = state;
    },
    updateMyProfile(params) {
      return _updateMyProfile(params);
    },
    updateProfileVisibleHandler(value) {
      if (value != null) {
        sessionStorage.setItem(KEY_PROFILE_UPDATED, value);
      }
      this.updateProfileVisible =
        sessionStorage.getItem(KEY_PROFILE_UPDATED) === 'true';
    },
    async getStudentInfo() {
      this.studentInfo = this.selectedStudentDetails;
    },
    async getEnrollmentSchool(studentSieId) {
      const result = (
        await studentService.getStudentEnrollmentDetail(studentSieId)
      ).data;

      this.enrollmentSchoolData = result?.map((item) => {
        let Ada = item.adaIndicator == '1' ? 'SÍ' : 'NO';
        Ada = item.adaIndicator == null ? 'No disponible' : Ada;
        return {
          schoolYear: item.schoolYear,
          effectiveStartDate: item.effectiveStarDate,
          effectiveEndDate: item.effectiveEndDate,
          region: item.region,
          district: item.district,
          municipality: item.municipality,
          school: `${item.extNumber || ''} - ${item.name || ''}`,
          adaIndicator: Ada,
          gradeLevel: item.gradeLevel,
          status: item.enrollmentEndStatusDescription,
        };
      });
    },
    async getStudentStatuses(statusId) {
      this.studentStatuses = (await _getStudentStatuses(statusId)).data;
    },
    async getStudentTherapies(studentSieId) {
      this.therapies = (await studentService.getTherapies(studentSieId)).data;
    },
    async getPeiHistory(studentSieId, year = 0, pageIndex = 1) {
      const result = (
        await _getStudentPeiHistory(
          studentSieId,
          year,
          pageIndex,
          DEFAULT_PEI_HISTORY_PAGE_SIZE
        )
      ).data;

      this.peiHistoryData = {
        ...result,
        pageSize: DEFAULT_PEI_HISTORY_PAGE_SIZE,
      };
    },
    async onChangeStatusHandler(
      { studentId, statusId: studentStatus },
      status
    ) {
      if (studentStatus == status.id) {
        this.ShowToast(
          'Error',
          'El estudiante ya se encuentra en este estatus.',
          'error'
        );
        return;
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que quiere cambiar a ${status.name} este estudiante?`
      );
      if (answer && studentId && status?.id) {
        const categoryId = this.getCategoryType(status.id);
        commentsStore.commit('setSelectedCategory', categoryId);
        commentsStore.commit('setSelectedModule', MODULES.STUDENT);

        const currentRoute = this.$route;
        const newRoute = {
          name: 'studentAddComment',
          params: {
            isReadOnly: true,
            commentId: null,
            commentDate: new Date(),
            commentCategoryTypeId: categoryId,
          },
        };

        // this avoid the error of the same route
        if (currentRoute.name !== newRoute.name) {
          this.$router.push(newRoute);
        }
        // if current route is the same as new route, we need to push to another route and then push to the new route
        else {
          this.$router.push({ name: 'student-menu' });
          setTimeout(() => {
            this.$router.push(newRoute);
          }, 100);
        }

        this.onCloseStudentSearchHandler();
      }
    },
    getCategoryType(status) {
      switch (status) {
        case EnumStudentStatuses.PreRegistro:
          return commentTypes.EstudiantePreRegistro;

        case EnumStudentStatuses.Registro:
          return commentTypes.EstudianteRegistro;

        case EnumStudentStatuses.Evaluado:
          return commentTypes.EstudianteEvaluado;

        case EnumStudentStatuses.Inactivo:
          return commentTypes.EstudianteInactivo;

        case EnumStudentStatuses.Disponible:
          return commentTypes.EstudianteDisponible;

        case EnumStudentStatuses.NoElegible:
          return commentTypes.EstudianteNoElegible;
      }
    },
    async onChangeMunicipalityHandler({ studentId }, municipality) {
      if (studentId && municipality?.id) {
        //update status
        await studentService.updateMunicipality(studentId, municipality.id);
        await this.getStudentInfo();
        await this.ShowToast(
          '',
          'Los datos fueron guardados exitosamente.',
          'success'
        );

        this.studentInfo = {
          ...this.studentInfo,
          mipeStudent: {
            ...this.studentInfo.mipeStudent,
            municipality: status.name,
          },
        };
      }
    },
    async onUpdateStudentSieHandler({ studentId }) {
      if (studentId) {
        //update student sie
        await studentService.updateStudent(studentId);

        this.ShowToast(
          '',
          'Los datos fueron actualizados exitosamente.',
          'success'
        );

        //get student data
        await this.getStudentInfo();
        await this.getStudentTherapies(studentId);
      }
    },
    async onRefreshAddressHandler({ studentId }) {
      if (studentId) {
        const response = (await studentService.getAddress(studentId)).data;
        if (response) {
          this.studentInfo = response;
        }
      }
    },
    updateStudentDates(payload) {
      return _updateStudentDates(payload);
    },
    async getMunicipalities() {
      await getMunicipalities().then((res) => {
        this.municipalityList = res.data;
      });
    },
    async handleSubmitChangePassword(e) {
      this.ShowWait();
      let payload = {
        currentPassword: e.currentPassword,
        confirmPassword: e.confirmPassword,
        newPassword: e.newPassword,
      };
      let vm = this;

      const { data } = await changeUserPassword(payload)
        .catch(function(error) {
          vm.ShowToast('', error.response.data.message, 'error');
        })
        .finally(() => {
          this.HideWait();
        });

      if (!data.error) {
        this.showModalPassword = false;

        this.ShowToast(
          'Proceso Exitoso',
          'Su contraseña ha sido cambiada exitosamente.',
          'success'
        );

        vm.$router.go('/dashboard');

        return;
      }
    },
    displayModalPassword() {
      this.showModalPassword = true;
    },
    onCloseStudentSearchHandler() {
      this.studentSieId = null;
      store.commit('$_student/setNavigationToViewDisplay', false);
    },
    handleOpenCloseTicketFlow() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-create-ticket');
    },
    handleOpenCloseVirtualAssistant() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-virtual-assistant');
    },
    handleNavigateToMyTickets() {
      router.push({ name: 'CaseListMain' });
    },
    async onUpdateImpedimentHandler({ studentId }) {
      if (!studentId) return;

      try {
        await studentService.updateStudentImpediment(studentId);

        await store.dispatch('$_student/setStudentDetails', {
          studentId: studentId,
          autoCreateStudentData: true,
          student: this.selectedStudent,
          selectThisStudent: true,
        });

        await this.getStudentInfo();

        this.ShowToast(
          '',
          'Los datos fueron actualizados exitosamente.',
          'success'
        );
      } catch (error) {
        this.ShowToast(
          'Error',
          'Hubo un problema al actualizar los datos.',
          'error'
        );
      }
    },
  },
  computed: {
    ...mapGetters({
      isMobile: 'getIsMobileDensity',
      isAiAssistantDocked: 'getIsAiAssistantDocked',
      user: '$_user/fullProfile',
    }),
    logoImgUrl() {
      if (this.isTrainingEnv()) return logoTrainingUrl;
      return logoUrl;
    },
    // El navbar es fixed-top (position: fixed; right: 0 por Bootstrap) -- al igual que
    // .page-content en Layout.vue, se le angosta el borde derecho cuando el panel docked
    // del Asistente de IA está abierto, para que la búsqueda y el perfil (CustomUserInfo,
    // pinneado al borde derecho del navbar) no queden debajo del panel.
    navStyle() {
      return {
        transition: 'right 0.22s ease',
        // Mismo ancho que el panel (variable global --ai-assistant-panel-width).
        right: this.isAiAssistantDocked
          ? 'var(--ai-assistant-panel-width)'
          : '0px',
      };
    },
    // Reemplaza los flags sueltos (isMobile crudo, isAiAssistantDocked, @media
    // por ancho de ventana) por una medición real del espacio disponible del
    // navbar (ver ResizeObserver en mounted()) -- así el modo compacto/crítico
    // reacciona igual sin importar si lo angosta una ventana pequeña, el panel
    // docked del Asistente IA, o ambos a la vez. `isMobile` se mantiene como
    // respaldo para que no haya un parpadeo inicial antes de la primera
    // medición del observer.
    navCompact() {
      return (
        this.isMobile ||
        (this.navAvailableWidth !== null && this.navAvailableWidth < 1300)
      );
    },
    // Cuando ni el modo compacto alcanza a caber (ej. panel docked + pantalla
    // ya angosta), el logo se reduce a solo el ícono de la hoja.
    navCritical() {
      return this.navAvailableWidth !== null && this.navAvailableWidth < 390;
    },
    selectedStudent() {
      return store.state.$_student.selectedStudent;
    },
    selectedStudentDetails() {
      return store.state.$_student.details;
    },
    hasStudentSelected() {
      let student = store.state.$_student.selectedStudent;
      return student != null;
    },
    studentSelected() {
      return store.state.$_student.selectedStudent;
    },
    showSelectedStudent() {
      return store.state.$_student.showSelectedStudent;
    },
    //Show information about student in SIE Modal
    isStudentSet() {
      return store.getters['$_student/StudentSie'];
    },
    isStudentForView() {
      return store.state.$_student.sieForModal != '';
    },
    userCard() {
      let user = this.user;
      return {
        rowElements: [
          {
            text: user.role,
            icon: 'fas fa-key',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: user.name,
            icon: 'fas fa-user',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: user.email || '-',
            icon: 'fas fa-envelope',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
        ],
        rowActions: [
          {
            text: 'Mi Perfil',
            icon: 'fas fa-address-card',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => this.profileModalVisibilityHandler(true),
          },
          {
            text: 'Cambiar Contraseña',
            icon: 'fas fa-repeat-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => {
              this.displayModalPassword();
            },
          },
          {
            text: 'Salir',
            icon: 'fas fa-sign-out-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: this.logoff,
          },
        ],
        lastLogin: user.lastLoginDate,
      };
    },
    showBtnUpdateImpediment() {
      const statuses = [
        EnumStudentStatuses.Servido,
        EnumStudentStatuses.Elegible,
      ];
      return (
        statuses.includes(+this.studentInfo?.mipeStudent?.studentStatusCode) &&
        (this.studentInfo?.mipeStudent?.impedimentId == null ||
          this.studentInfo.mipeStudent.impedimentId === 0) &&
        this.userHasPermissions('student.impediment.update')
      );
    },
  },
  async mounted() {
    this.StudentSearchedHistory();
    this.observeNavWidth();
  },
  beforeDestroy() {
    if (this._navResizeObserver) {
      this._navResizeObserver.disconnect();
      this._navResizeObserver = null;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

// El hamburguesa nunca debe encogerse/desaparecer cuando el navbar se
// angosta (panel docked del Asistente IA + pantalla ya angosta) -- ver
// computed navCritical, que libera espacio reduciendo el logo en su lugar.
#burger {
  flex-shrink: 0;
}

// Espacio crítico (navCritical, ver script): el logo completo
// (academico.svg, ícono + texto "MiPE ACADÉMICO" en un solo archivo) no cabe
// junto al hamburguesa y los íconos del navbar -- en vez de un asset nuevo,
// se recorta el propio SVG a solo su ícono (el grupo del ícono, "Group_806",
// arranca en x=0 del viewBox, así que un contenedor angosto con
// overflow:hidden y el <img> escalado por altura deja ver solo la hoja).
.sidebar-heading--critical {
  width: 32px;
  height: 32px;
  overflow: hidden;
  padding: 0 !important;
}
.sidebar-heading--critical img {
  width: auto !important;
  height: 32px !important;
  max-width: none !important;
  margin: 0 !important;
}

.div-help {
  margin-left: -10px;
  color: #ff7058;
}
.help-text {
  margin-left: -10px;
}
.help-information {
  margin-left: -10px !important;
}
.information-text {
  margin-left: -7px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
}
.support-table {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.support-information {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #20a874 !important;
  opacity: 1;
}
.support-label {
  margin-left: 11px !important;
  text-decoration: underline;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
}
.shadow-top {
  -moz-box-shadow: inset 0 10px 10px -10px grey;
  -webkit-box-shadow: inset 0 10px 10px -10px grey;
  box-shadow: inset 0 10px 10px -10px grey;
}
.alert-indicator {
  position: absolute;
  top: 32px;
  right: 157px;
  background: #fd3737 0% 0% no-repeat padding-box;
  color: #fff;
  width: 15px;
  height: 15px;
  opacity: 1;
  line-height: 15px;
  text-align: center;
  font-size: 10px;
}

.dropdown-menu-custom {
  top: 165% !important;
  border: 0;
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
}

.form_button {
  font-size: 1rem;
  display: inline-flex;
  width: 48px;
  height: 48px;
  color: #fff;
  border-radius: 50%;
  border: #f8b539 1px solid;
  align-items: center;
  justify-content: center;
}

.form_icon {
  color: #f8b539;
  font-size: 20px;
}
.form_link {
  margin-bottom: auto;
  margin-top: auto;
  border: 1px solid #f8b539;
  border-radius: 30px;
  color: #f8b539;
  font-size: 18px;
  word-break: normal !important;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  width: 100%;
  line-height: 45px;
}

// El ícono va oculto por defecto -- "Formularios" arranca como pill de solo
// texto (comportamiento de siempre); .form_link--compact lo revela y esconde
// el texto, convirtiéndolo en círculo. Disparado por el computed navCompact
// (medición real del ancho del navbar, ver mounted()/observeNavWidth) -- ya
// no depende de un @media por ancho de ventana crudo, que no detectaba el
// angostamiento causado por el panel docked del Asistente IA.
.form-link-icon {
  display: none;
}
.form_link--compact {
  width: 40px;
  padding: 0 !important;
  border-radius: 50%;
  line-height: 40px;
}
.form_link--compact .form-link-icon {
  display: inline-block;
  font-size: 16px;
}
.form_link--compact .form-link-label {
  display: none;
}

.user-info__extended ::v-deep {
  .dropdown-menu-custom {
    margin-top: -7px;
  }

  @media only screen and (max-width: 768px) {
    .dropdown-menu-custom {
      left: -80px !important;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  ul.navbar-nav {
    width: 100% !important;
  }
}

@media screen and (max-width: 767px) {
  ul.navbar-nav {
    justify-content: space-evenly;
  }

  .user-info__extended ::v-deep > .user-panel > .dropdown-menu {
    margin-right: 23px;
  }
}

.custom-right {
  right: 0 !important;
  left: auto !important;
}

/* Red de seguridad: en pantallas angostas el panel docked pasa a ancho completo (ver
   media query espejo en AiAssistantModal.vue), así que el navbar no debe angostarse -- se
   necesita !important porque el estilo inline de navStyle() no lo tiene. */
@media (max-width: 680px) {
  .custom-navbar {
    right: 0 !important;
  }
}

.nav-icon-link:hover {
  text-decoration: none;
}

.nav-list-item {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 15px 15px;
}

.avatar.user-headset {
  background: #ff7058;
  border-color: #ff7058;
}

.avatar.user-headset .fa-user-headset {
  color: #fff;
}

.deticket-box {
  width: 200px;
}

.student-search-info__extended ::v-deep {
  .modal-mask {
    z-index: 1058 !important;
  }
}

.dropdown-help {
  button {
    border-radius: 52px;
    background: map-get($colors, 'orange') !important;
    padding: 11px 17px !important;
    border: unset !important;
    &:focus {
      box-shadow: unset !important;
    }
    &:after {
      border: none;
      font-family: 'Font Awesome 5 Pro';
      content: '\f107';
      margin-left: 0.5rem;
      color: #fff;
    }

    // Mismo tratamiento de solo-ícono que "Formularios": disparado por el
    // computed navCompact (medición real del ancho del navbar, ver
    // mounted()/observeNavWidth) -- reacciona igual sin importar si lo angosta
    // una ventana pequeña, el panel docked del Asistente IA, o ambos a la vez.
    // El ícono conserva "mr-2" (pensado para cuando el texto "Ayuda" está al
    // lado) -- se anula aquí para que quede realmente centrado en el círculo.
    &.dropdown-toggle-help--compact {
      width: 40px;
      height: 40px;
      padding: 0 !important;
      justify-content: center;
      .help-btn-label {
        display: none;
      }
      &:after {
        display: none;
      }
      img {
        width: 16px;
        height: 16px;
        margin: 0 !important;
      }
    }
  }

  .dropdown-menu {
    .dropdown-item {
      margin-bottom: 7px;
      &:active {
        img {
          background: #fff !important;
        }
      }
    }
  }
}
</style>
